// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ← Replace with your own config from Firebase Console → Project Settings
const firebaseConfig = {
    apiKey: "AIzaSyCf1vXIcotBr6Hl6UR_a5A7Z9hITqMXbiE",
    authDomain: "lastoria-new.firebaseapp.com",
    projectId: "lastoria-new",
    storageBucket: "lastoria-new.firebasestorage.app",
    messagingSenderId: "147668284778",
    appId: "1:147668284778:web:832c827eb5d504be662113"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
